import type { ContentObjectList, NonEventContentObjectDetail } from 'models';
import { useNavigate } from 'react-router';
import { Button, EyeLineIcon } from 'ui';
import { generateContentObjectPath } from 'features/copy-to-clipboard';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
};

const ViewButton = ({ item }: P) => {
  const navigate = useNavigate();

  return (
    <Button
      icon={<EyeLineIcon />}
      onClick={async () => {
        // TODO: This should not be in feature
        await navigate(generateContentObjectPath(item));
      }}
      size="large"
      type="text"
    >
      View
    </Button>
  );
};

export default ViewButton;
